import { Currency } from "~/entities/currencyEntities";
import Client from "../baseClient";

export const CurrencyApi = {
  getCurrency: async (orgId: string, siteId: string) =>
    await Client.get<Currency>(`${orgId}/${siteId}/currency`),
};
